<template>
    <span class="progress-mark" :data-progress="statusDetails.progress" v-html="iconForProgress()"/>
</template>

<script>
    import tippy from 'tippy.js';
    import 'tippy.js/dist/tippy.css';
    import 'tippy.js/dist/svg-arrow.css';
    import 'tippy.js/animations/shift-toward-subtle.css';
    import {roundArrow} from 'tippy.js';

    export default {
        name: "ReceiveStatusProgressMarks",
        props: {
            statusDetails: {type: Object},
            hasTooltip: {type: Boolean, default: true},
        },
        methods: {
            iconForProgress() {
                if (this.statusDetails.progress < 0) {
                    return `<ion-icon ios='alert-circle' md="alert-circle" slot="end"/>`;
                }
                if (this.statusDetails.progress <= 0) {
                    return `<ion-icon ios='time' md="time" slot="end"/>`;
                }
                if (this.statusDetails.progress <= 2) {
                    return `<ion-icon ios='checkmark-circle' md="checkmark-circle" slot="end"/>`;
                }

                return `<ion-icon ios='checkmark-done-circle' md="checkmark-done-circle" slot="end"/>`;
            },
            setTooltip() {
                this.$nextTick(async () => {
                    tippy(this.$el.getElementsByTagName('ion-icon')[0], {
                        content: `${this.statusDetails.label}`,
                        placement: 'bottom',
                        arrow: roundArrow,
                        interactive: true,
                        appendTo: document.body,
                    });
                });
            },
        },
        updated() {
            this.setTooltip();
        },
        mounted() {
            this.setTooltip();
        },
    }
</script>

<style lang="scss">
    .progress-mark {
        color: #888888;

        &[data-progress="-1"] {
            color: red;
        }

        &[data-progress="3"] {
            color: var(--ion-color-success);
        }

        &[data-progress="1"], &[data-progress="2"], &[data-progress="3"] {
            ion-icon {
                font-size: 24px;
                top: -1px;
            }
        }

        ion-icon {
            color: inherit;
            font-size: 20px;
            margin-left: 3px;
            margin-right: -4px;
            position: relative;
            top: -3px;
        }
    }
</style>
